export default {
  'menu.home': 'Home',
  'menu.login': 'Login',
  'menu.logout': 'Logout',
  'menu.dashboard': 'Dashboard',
  'menu.welcome': 'Welcome',
  'menu.merchant': 'Merchant',
  'menu.developer': 'Developer settings',
  'menu.merchant.center': 'Merchant center',
  'menu.merchant.settings': 'Merchant settings',
  'menu.merchant.walletaddress': 'Merchant wallet address',
  'menu.orderin': 'Orderin',
  'menu.orderout': 'Orderout',
  'menu.order.export': 'Order export',
  'menu.asset': 'Asset',
  'menu.asset.cash': 'Asset cash',
  'menu.asset.logs': 'Asset logs',

  'menu.exception.403': '403',
  'menu.exception.404': '404',
  'menu.exception.500': '500',

  'menu.result': 'Result',
  'menu.result.success': 'Success',
  'menu.result.fail': 'Fail',
  'menu.exception': 'Exception',
  'menu.exception.not-permission': '403',
  'menu.exception.not-find': '404',
  'menu.exception.server-error': '500',
  'menu.exception.trigger': 'Trigger Error',

};
